// Categorical colours shared by charts and maps (one colour per series, category or day).
export const CATEGORY_PALETTE = ['#1c79bb', '#4CAF50', '#FF9800', '#9C27B0', '#00ACC1', '#E7003E', '#7986CB', '#8D6E63'];
